/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyle = makeStyles(theme => ({
  spb: {
    fontFamily: 'SofiaProBold',
  },
  spl: {
    fontFamily: 'SofiaProLight',
  },
  fsb: {
    fontFamily: 'FiraSansBold',
  },
  fs: {
    fontFamily: 'FiraSans',
  },
  white: {
    color: theme.palette.white,
  },
  green: {
    color: theme.palette.primary.main,
  },
  uppercase: {
    textTransform: 'uppercase',
  },
}));

export const Text = ({
  variant,
  labelColor,
  children,
  bold,
  uppercase,
  ...rest
}) => {
  const styles = useStyle();

  const isUppercase = uppercase && styles.uppercase;
  const getColor = labelColor === 'main' ? styles.white : styles.green;

  return (
    <Typography
      variant={variant}
      className={`${getColor} ${isUppercase}`}
      {...rest}
    >
      {children}
    </Typography>
  );
};

Text.defaultProps = {
  bold: false,
  uppercase: false,
  labelColor: 'main',
};

Text.propTypes = {
  variant: PropTypes.string.isRequired,
  labelColor: PropTypes.oneOf('main', 'primary'),
  bold: PropTypes.bool,
  uppercase: PropTypes.bool,
};
